import { products } from "./mockData";
import { code46NewProducts } from "./code46NewData";

// Классическая линейка (тёмный корпус)
export const code46ClassicProducts = products.map((p) => ({
  ...p,
  id: `c${p.id}`,
  color: "classic",
  isNew: false,
}));

// Новинки и классику показываем вперемешку — иначе первая страница целиком
// состоит из новинок. Отобрать только новое можно кнопкой «Новинки».
const interleave = (a, b) => {
  const result = [];
  for (let i = 0; i < Math.max(a.length, b.length); i += 1) {
    if (i < a.length) result.push(a[i]);
    if (i < b.length) result.push(b[i]);
  }
  return result;
};

// Полный каталог CODE 46
export const code46Products = interleave(code46NewProducts, code46ClassicProducts);

export default code46Products;
